import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import translationEN from './locales/en.json';
import translationDE from './locales/de.json';

const url = new URL(window.location.href)
const searchParams = new URLSearchParams(url.search);


export function setURL(languageCode) {
    if (languageCode === "en") {
        searchParams.set("lang", "en")
    } else {
        searchParams.set("lang", "de")
    }
    let newUrl = new URL('?' + searchParams.toString(), url.origin);
    window.history.pushState({}, "", newUrl.toString());
}

i18n
    .use(detector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: {
            en: {
                translation: translationEN
            },
            de: {
                translation: translationDE
            }
        },
        lng: searchParams.get("lang") === 'en' ? "en" : "de",
        fallbackLng: "de",
        escapeInterpolation: false,

        interpolation: {
            escapeValue: false
        },
        joinArrays: ' ',
        skipInterpolation: true,
        returnObjects: true
    });

export default i18n;
